const ModalType = {
  DefaultModal: 'DefaultModal',
  CreateUserModal: 'CreateUserModal',
  EditAuctionModal: 'EditAuctionModal',
  ConfirmationModal: 'ConfirmationMdal',
  CommentModal: 'CommentModal',
  EditCarModal: 'EditCarModal',
  DeclineCarModal: 'DeclineCarModal',
  ChangePasswordModal: 'ChangePasswordModal',
  BlogModal: 'BlogModal',
  SeoModal: 'SeoModal',
  AuctionBannerModal: 'AuctionBannerModal',
  AuctionBannerModal: 'AuctionBannerModal',
  ForgotPasswordModal: 'ForgotPasswordModal',
  CommentsModal: 'CommentsModal',
  EditMarketplaceModal: 'EditMarketplaceModal',
  VdpModal: 'VdpModal',
  ViewTeslaVehicle: 'ViewTeslaVehicle',

}

export default ModalType
